export const TOKEN_TYPE = "Bearer ";
export const REQUEST_HEADER_AUTH_KEY = "Authorization";
export const Reachyo_AUTH_HEADER_KEY = "Basic c21saWNybTpTbWxpQENSTTI0";

export const AUTH_APIS = {
  ADMIN_LOGIN: "admin/login",
  VERIFY_OTP: "admin/verifyOtp",
  CHANGE_PASSWORD: "admin/changePassword",
  ADMIN_LOGOUT: "admin/logout",
};
export const APP_APIS = {
  IMPORT_FILE: "admin/importFile",
  EXPORT_FILE: "admin/exportFile",
  CHANGE_PASSWORD: "admin/changePassword",
  QUERIES: "admin/listQueries",
  CANDIDATES: "admin/listCandidates",
  ADMIN: "admin/listSubAdmin",
  ADD_EDIT_ADMIN: "admin/addEditSubAdmin",
  CHANGE_STATUS: "admin/changeStatus",
  ADD_CANDIDATES: "admin/addEditCandidate",
  ADD_CANDIDATES_NOTES: "admin/addEditCandidateNote",
  TEMPLATES_LIST: "admin/listWhatsappTemplates",
  BROADCAST_MESSAGE: "admin/broadcastMessage",
  DELETE_CANDIDATE: "admin/deleteCandidate",
  DELETE_TEMPLATE: "admin/deleteTemplate",
  CAMPAIGN_LIST: "admin/listCampaigns",
  META_INFO: "admin/listWBMetaInfo",
  TEMPLATE_INSIGHTS: "admin/listTemplateInsights",
  CAMPAIGN_INSIGHTS: "admin/listCampaignStats",
  CONVERSATIONS: "admin/listConversations",
  CHATS: "admin/listChats",
  SEND_MESSAGE: "admin/sendTextMessage",
  SEND_MULTIPLE_MEDIA: "admin/sendMultipleMedia",
  CREATE_TEMPLATE: "admin/createTemplate",
};
